var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      class: _vm.$page.props.staffView ? null : "container",
      attrs: {
        page: "/help-categories",
        pageTitle: _vm.article.title,
        backLink: _vm.route(
          "help-categories.show",
          _vm.article.help_category_id
        ),
        tabs: true,
      },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-row",
                {
                  staticClass: "mr-8",
                  attrs: {
                    align: "center",
                    "no-gutters": _vm.$vuetify.breakpoint.mdAndUp,
                  },
                },
                [
                  _vm.$vuetify.breakpoint.smAndDown
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "my-3",
                          attrs: { icon: "", color: "dark" },
                          on: {
                            click: function ($event) {
                              _vm.drawer = !_vm.drawer
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("menu")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-breadcrumbs", {
                    staticClass: "px-1 py-3 whitespace-nowrap overflow-hidden",
                    class: { "custom-breadcrumbs": _vm.$vuetify.breakpoint.xs },
                    attrs: { items: _vm.breadcrumbs },
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.can("Edit help articles")
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "soli-round",
                          attrs: {
                            href: `/admin/help-article/${_vm.article.id}/edit`,
                            "x-small": "",
                            color: "error",
                            outlined: "",
                          },
                        },
                        [
                          _vm._v("Edit "),
                          _c(
                            "v-icon",
                            { attrs: { right: "", "x-small": "" } },
                            [_vm._v("edit")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.article.toc
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "toc elevation-2 mt-1 right-round",
              class: {
                "pt-12": _vm.$vuetify.breakpoint.smAndDown,
                "overflow-unset": _vm.$vuetify.breakpoint.mdAndUp,
              },
              attrs: {
                app: _vm.$vuetify.breakpoint.smAndDown,
                absolute: _vm.$vuetify.breakpoint.mdAndUp,
                permanent: _vm.$vuetify.breakpoint.mdAndUp,
                floating: "",
              },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { position: "sticky", top: "64px" } },
                [
                  _c("v-card-title", [_vm._v("Table of Contents")]),
                  _vm._v(" "),
                  _c("v-card-text", {
                    staticClass: "toc-content prose",
                    domProps: { innerHTML: _vm._s(_vm.article.toc) },
                    on: {
                      click: function ($event) {
                        _vm.drawer = false
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass: "py-0",
          class: [
            _vm.$vuetify.breakpoint.mdAndUp && _vm.article.toc
              ? "offset"
              : null,
          ],
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: 12 } },
                [
                  _c("v-card-text", {
                    class: {
                      "prose md:prose-lg lg:prose-xl": true,
                      "wysiwyg-display": false,
                    },
                    domProps: { innerHTML: _vm._s(_vm.article.content) },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }